import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/**
 * Handles API errors by displaying a toast notification.
 * Falls back to a default message if the error shape is unexpected.
 *
 * @param {object} error - The error object caught from a request.
 * @param {string} defaultMessage - Message to show when specific details are unavailable.
 */
const handleApiError = (error, defaultMessage = 'An error occurred') => {
  if (error?.response) {
    const { status, data } = error.response;
    switch (status) {
      case 400:
        toast.error(data?.message || 'Bad request');
        break;
      case 401:
        toast.error('Unauthorized – please log in again');
        break;
      case 403:
        toast.error('Forbidden – you do not have access');
        break;
      case 404:
        toast.error('Resource not found');
        break;
      case 422:
        if (data?.errors) {
          const messages = Object.values(data.errors).flat().join(', ');
          toast.error(messages || 'Validation error');
        } else {
          toast.error(data?.message || 'Unprocessable entity');
        }
        break;
      case 500:
        toast.error('Server error – please try again later');
        break;
      default:
        toast.error(data?.message || defaultMessage);
    }
  } else if (error?.message) {
    toast.error(error.message);
  } else {
    toast.error(defaultMessage);
  }
};

export default handleApiError;
